module.exports = __webpack_public_path__ + "img/collaborative-office.6ef4fae.png";